(() => {
  const money = (cents, format) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'PLN'
      }).format(value);
    } catch (_) {
      return `${value.toFixed(2).replace('.', ',')} zł`;
    }
  };

  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const wrapper = quantityButton.closest('[data-quantity]');
      const input = wrapper?.querySelector('input[type="number"]');
      if (!input) return;
      const step = Number(input.step || 1);
      const min = Number(input.min || 1);
      const direction = quantityButton.dataset.quantityChange === 'increase' ? 1 : -1;
      input.value = Math.max(min, Number(input.value || min) + (direction * step));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const thumb = event.target.closest('[data-product-thumbnail]');
    if (thumb) {
      const main = document.querySelector('[data-product-main-image]');
      if (main && thumb.dataset.imageSrc) {
        main.src = thumb.dataset.imageSrc;
        main.srcset = '';
        document.querySelectorAll('[data-product-thumbnail]').forEach((el) => el.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      }
    }
  });

  document.addEventListener('change', (event) => {
    const variantSelect = event.target.closest('[data-variant-select]');
    if (variantSelect) {
      const option = variantSelect.selectedOptions[0];
      const root = variantSelect.closest('[data-product-root]');
      const price = root?.querySelector('[data-product-price]');
      const button = root?.querySelector('[data-add-to-cart]');
      if (price && option) price.textContent = money(option.dataset.price);
      const mainImage = root?.querySelector('[data-product-main-image]');
      if (mainImage && option?.dataset.imageSrc) {
        mainImage.src = option.dataset.imageSrc;
        mainImage.srcset = '';
      }
      if (button && option) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableText : button.dataset.soldOutText;
      }
    }

    const qrToggle = event.target.closest('[data-qr-toggle]');
    if (qrToggle) {
      const field = document.getElementById(qrToggle.getAttribute('aria-controls'));
      if (field) {
        field.hidden = !qrToggle.checked;
        const input = field.querySelector('input');
        if (input) input.disabled = !qrToggle.checked;
      }
    }
  });

  document.querySelectorAll('[data-use-tabs]').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('[role="tab"]');
    const panels = tabs.querySelectorAll('[role="tabpanel"]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => item.setAttribute('aria-selected', 'false'));
        panels.forEach((panel) => { panel.hidden = true; });
        button.setAttribute('aria-selected', 'true');
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
      });
    });
  });
})();
